import React from 'react';
import { motion } from 'framer-motion';
import { XIcon, CheckIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
const rows = [{
  situation: 'El cliente pregunta el precio',
  without: 'Improvisás',
  with: 'Argumento listo. Lo cobrás.'
}, {
  situation: 'Querés subir el precio',
  without: 'No sabés cómo',
  with: 'Estrategia paso a paso'
}, {
  situation: 'Fotos en redes',
  without: 'No generan consultas',
  with: 'Sistema foto activado'
}, {
  situation: 'El cliente no vuelve',
  without: 'Sin sistema',
  with: 'Protocolo de fidelización'
}, {
  situation: 'Tu reputación',
  without: 'Como cualquier barbero',
  with: 'Referente premium en tu zona'
}];
export function ProComparison() {
  return <section aria-label="Qué agrega el PRO" className="border-b border-ink-700 bg-ink-950 py-16 sm:py-20" data-id="element-162" data-mp="3qngf1epelr8d">
      <div className="mx-auto w-full max-w-page px-5 sm:px-8" data-id="element-163" data-mp="3gnv0393ghel">
        <SectionHeading label="Upgrade" title="⬆️ ¿Qué agrega el PRO?" data-id="element-164" data-mp="3ih1nijpj1ml" />

        <ul className="mt-10 grid gap-px bg-ink-700" data-id="element-165" data-mp="2qudcjt3jmyip">
          {rows.map((row, i) => <motion.li key={row.situation} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.4,
          delay: i * 0.05
        }} className="grid gap-4 bg-ink-900 p-6 md:grid-cols-3 md:items-center md:gap-6" data-id="element-166" data-mp="2vrlo3au6s4az" data-mpi={i}>
              <p className="display text-base text-bone sm:text-lg" data-id="element-167" data-mp="3eqzg3n8cv4yu">{row.situation}</p>
              <p className="flex items-start gap-3 text-sm text-ash sm:text-base" data-id="element-168" data-mp="3jhzd0shh5n1c">
                <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-alert" aria-hidden="true" data-id="element-169" data-mp="3jkbu73fertdc" />
                <span data-id="element-170" data-mp="3oj58gy2iroek">
                  <span className="mr-2 text-[10px] font-bold uppercase tracking-widest text-ash/70 md:hidden" data-id="element-171" data-mp="3tg5cz4jq0j3k">
                    Sin PRO
                  </span>
                  {row.without}
                </span>
              </p>
              <p className="flex items-start gap-3 text-sm font-semibold text-bone sm:text-base" data-id="element-172" data-mp="1ye1zpbhwwt9k">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-ice" aria-hidden="true" data-id="element-173" data-mp="1teytvou3yj0j" />
                <span data-id="element-174" data-mp="275kjrxhzbt7x">
                  <span className="mr-2 text-[10px] font-bold uppercase tracking-widest text-ash/70 md:hidden" data-id="element-175" data-mp="276vi3hsno8rn">
                    Con PRO
                  </span>
                  {row.with}
                </span>
              </p>
            </motion.li>)}
        </ul>
      </div>
    </section>;
}